import React from 'react';
import {GridValidRowModel} from '@mui/x-data-grid-pro';
import {StickyDataGrid} from '../../../components/Common/StickyDataGrid';
import {useHardFacts} from '../../../hooks/useHardFacts';
import {ErrorPage} from '../../../pages/ErrorPage';
import {retirementColumns} from './RetirementPlanningColumns';

export const RetirementPlanningTable: React.FC = () => {
  const {data, error, loading} = useHardFacts();
  const retirementRows = data?.hardFacts?.gifts ?? [];

  if (error) {
    return <ErrorPage text={error.message} />;
  }

  return (
    <StickyDataGrid
      sx={{
        overflowY: 'scroll',
        height: '250px',
      }}
      rowHeight={40}
      rows={retirementRows as readonly GridValidRowModel[]}
      columns={retirementColumns}
      hideFooter
      loading={loading}
    />
  );
};
